import React from 'react';
import { useSelector } from 'react-redux';

import VoiceSelectionModalPresentationV2 from './VoiceSelectionModalPresentationV2';

import type { VoiceSelectionModalContext } from 'js/src/data/modals';
import { getModalContext, isAIVoiceSelectionModalShowing } from 'js/src/data/modals';

const VoiceSelectionModal = () => {
    const isShowing = useSelector(isAIVoiceSelectionModalShowing);
    const modalContext = useSelector(getModalContext<VoiceSelectionModalContext>);

    const source = modalContext?.source;
    const initialSelectedVoiceId = modalContext?.initialSelectedVoiceId;
    const initialVoiceSpeed = modalContext
        ? 'initialVoiceSpeed' in modalContext
            ? modalContext.initialVoiceSpeed
            : 1
        : undefined;
    const onRemoveVoiceover = modalContext?.onRemoveVoiceover;
    const onApply = modalContext?.onApply;
    const onBack = modalContext?.onBack;

    return (
        <VoiceSelectionModalPresentationV2
            source={source}
            isShowing={isShowing}
            initialSelectedVoiceId={initialSelectedVoiceId}
            initialVoiceSpeed={initialVoiceSpeed}
            onRemoveVoiceover={onRemoveVoiceover}
            onApply={onApply}
            onBack={onBack}
        />
    );
};
export default VoiceSelectionModal;
